var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 96,
    viewBox: "0 0 95 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.5 95.08C73.7335 95.08 95 73.8135 95 47.58C95 21.3464 73.7335 0.0799561 47.5 0.0799561C21.2665 0.0799561 0 21.3464 0 47.58C0 73.8135 21.2665 95.08 47.5 95.08Z",
    fill: "#75B2FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.5076 36.9345C59.5076 43.8329 54.1074 49.3643 47.3675 49.3643C40.6298 49.3643 35.2274 43.8329 35.2274 36.9345C35.2274 30.0361 40.6298 24.5071 47.3675 24.5071C54.1074 24.5071 59.5076 30.0361 59.5076 36.9345ZM47.3675 71.4824C37.4205 71.4824 29.022 69.8265 29.022 63.4378C29.022 57.0467 37.4733 55.4496 47.3675 55.4496C57.3168 55.4496 65.713 57.1054 65.713 63.4941C65.713 69.8852 57.2618 71.4824 47.3675 71.4824Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.86e080c35e684630fd1654b66766408b.svg";
export { ForwardRef as ReactComponent };